module.exports = __webpack_public_path__ + "static/video-vot-intro-back-bbd8238b7e0af03aadd857b29bf5be9b.mp4";